<template>
  <!-- 輔導評價頁 -->
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px">
    <v-card>
      <v-card-title>
        <span class="title ml-3">輔導評價</span>
      </v-card-title>

      <v-card-text ref="cardText" class="card-text">
        <v-form ref="form" v-model="valid">
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs5 class="avatar-box">
                <app-avatar :size="128" :id="studentProfile.avatar" />
                <div class="title pa-3">{{studentName}}</div>
              </v-flex>


              <v-flex xs6 offset-xs1>
                <div>
                  <v-select
                    v-model="fudaoType"
                    :items="fudaoTypeOptions"
                    label="輔導方式"
                    :rules="fudaoTypeRules"
                    color="black"
                    no-data-text='' />

                  <v-select
                    v-model="suggestion"
                    :items="suggestionOptions"
                    label="給學生的建議"
                    :rules="suggestionRules"
                    color="black"
                    no-data-text='' />
                </div>
              </v-flex>

              <v-slide-y-transition>
                <v-flex v-if="suggestion === '其他'" xs12>
                  <v-textarea
                    class="animate-fadeIn-highlight"
                    v-model="otherSuggestion"
                    color="black"
                    :rows="2"
                    :height="48"
                    :rules="otherSuggestionRules"
                    label="其他建議"/>
                </v-flex>
              </v-slide-y-transition>

              <v-flex xs12>
                <v-select
                  class="chip-select"
                  v-model="subjects"
                  :items="subjectOptions"
                  label="輔導科目"
                  :rules="subjectsRules"
                  :menu-props="{'closeOnContentClick': true}"
                  color="black"
                  no-data-text=""
                  hide-selected
                  deletable-chips
                  small-chips
                  chips
                  multiple />
              </v-flex>

              <v-flex xs12>
                <v-combobox
                  @change="onKnowledgesChange"
                  v-model="knowledges"
                  :search-input.sync="knowledgeKeyword"
                  :items="knowledgeOptions"
                  :loading="loadingKnowledge"
                  label="學生問題所屬知識點"
                  :rules="knowledgesRules"
                  :menu-props="{'closeOnContentClick': true}"
                  color="black"
                  no-data-text=''
                  item-text="title"
                  item-value="_id"
                  hide-selected
                  chips
                  multiple>
                  <template slot="selection" slot-scope="data">
                    <v-chip
                      @input="removeKnowledges(data.item)"
                      :selected="data.selected"
                      color="secondary"
                      close
                      small>
                      <span>{{data.item.title}}</span>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>

              <v-flex class="mt-2" xs6>
                <app-rating-field ref="ratingBefore" v-model="ratingBeforeFudao" label="輔導前對觀念" />
              </v-flex>

              <v-flex class="mt-2" xs6>
                <app-rating-field ref="ratingAfter" v-model="ratingAfterFudao" label="輔導後對觀念" />
              </v-flex>

              <v-flex ref="errMsg">
                <v-alert
                  v-show="errMsg"
                  transition="slide-y-transition"
                  :value="true"
                  type="error">
                  {{errMsg}}
                </v-alert>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="showCancelBtn"
          @click="toggle"
          flat>
          取消
        </v-btn>

        <v-btn
          :loading="loading"
          color="primary"
          @click="submit"
          flat>
          送出
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';
import {scrollTo} from '@/lib/utils';

export default {
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      loadingKnowledge: false,
      errMsg: null,

      fudaoId: null,
      teacherId: null,
      studentProfile: {},

      fudaoType: null,
      suggestion: null,
      otherSuggestion: null,
      subjects: [],
      knowledges: [],
      knowledgeKeyword: null,
      ratingBeforeFudao: 0,
      ratingAfterFudao: 0,

      fudaoTypeOptions: [
        {text: '課程輔導', value: 'Lecture'},
        {text: '解題輔導', value: 'Answer'}
      ],
      suggestionOptions: ['積極學習', '被動學習', '欠缺方法', '缺乏基礎', '缺乏信心', '其他'],
      knowledgeOptions: [],

      fudaoTypeRules: [
        v => !!v || '請選擇輔導方式'
      ],
      suggestionRules: [
        v => !!v || '請選擇建議'
      ],
      otherSuggestionRules: [
        v => {
          let otherSuggestion = (v || '').trim();
          if (this.suggestion === '其他' && otherSuggestion === '') {
            return '請輸入建議';
          }
          return true;
        }
      ],
      subjectsRules: [
        v => !!v.length || '請選擇科目'
      ],
      knowledgesRules: [
        v => !!v.length || '請選擇知識點'
      ]
    };
  },

  props: {
    showCancelBtn: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters({
      subjectOptions: 'subjectOptions'
    }),

    studentName() {
      return this.studentProfile.nickname || this.studentProfile.username;
    }
  },

  watch: {
    dialog() {
      if (!this.dialog) {
        this.reset();
      }
    },

    knowledgeKeyword(value) {
      clearTimeout(this._searchTimeout);
      if (!value) {
        return;
      }
      this._searchTimeout = setTimeout(async () => {
        this.loadingKnowledge = true;
        try {
          this.knowledgeOptions = await this.getKnowledges(value);
        } catch (e) {
          console.error('query knowledges failed', e);
        } finally {
          this.loadingKnowledge = false;
        }
      }, 500);
    }
  },

  mounted() {
    this.$eventBus.$on('fudao-evaluation-student', this.open);
  },

  beforeDestroy() {
    this.$eventBus.$off('fudao-evaluation-student', this.open);
  },

  methods: {
    ...mapActions('fudao', {
      getKnowledges: 'getKnowledges',
      reportTeacherForm: 'reportTeacherForm',
      getProfileById: 'getProfileById'
    }),

    ...mapActions('alert', {
      addAlert: 'add'
    }),

    async open({fudaoId, teacherId, studentId}) {
      this.dialog = true;
      this.fudaoId = fudaoId;
      this.teacherId = teacherId;
      this.studentProfile = await this.getProfileById(studentId);
    },

    toggle() {
      this.dialog = !this.dialog;
    },

    async submit() {
      if (!this.$refs.form.validate()) {
        this.errMsg = '欄位輸入有誤';
        scrollTo(this.$refs.errMsg, this.$refs.cardText);
        return;
      }

      this.errMsg = null;
      this.loading = true;
      try {
        let teacherForm = {
          fudaoType: this.fudaoType,
          suggestion: this.suggestion === '其他' ? this.otherSuggestion : this.suggestion,
          fudaoSubjects: this.subjects,
          knowledgePoints: this.knowledges.map(k => k._id),
          ratingBeforeFudao: this.ratingBeforeFudao,
          ratingAfterFudao: this.ratingAfterFudao
        };
        await this.reportTeacherForm({
          teacherId: this.teacherId,
          fudaoId: this.fudaoId,
          teacherForm
        });
        this.$emit('submited');
      } catch (e) {
        this.addAlert({level: 'error', content: '評價發生錯誤'});
      } finally {
        this.loading = false;
        this.dialog = false;
      }
    },

    onKnowledgesChange(v) {
      if (!v.length) {
        return;
      }

      let lastItem = v[v.length-1];
      if (typeof lastItem !== 'object' || !lastItem._id) {
        v.splice(v.length-1, 1);
      }
    },

    removeKnowledges(item) {
      let index = this.knowledges.findIndex(s => s._id === item._id);
      this.knowledges.splice(index, 1);
    },

    reset() {
      this.errMsg = null;
      this.$refs.cardText.scrollTop = 0;
      this.$refs.form.reset();
    }
  }
};
</script>

<style lang="stylus" scoped>

.avatar-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card-text {
  overflow: auto;
  max-height: 70vh;
}

.rating-label {
  font-size: 16px;
  color: rgba(0,0,0,.54);
}

.rating-stars {
  position: relative;
  left: -8px;
  margin-top: 4px;
}

.chip-select >>> .v-chip {
  background-color: $secondary-color;
}

.field-error {
  label {
    color: $error-color;
  }

  .error-message {
    display: block;
  }
}

.error-message {
  font-size: 12px;
  color: $error-color;
  display: none;
}
</style>
